import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { PageWelcome } from '../components/PageWelcome.jsx';
import { ProgressBar } from '../components/ProgressBar.jsx';
import { StatusBadge } from '../components/StatusBadge.jsx';
import { useAuth } from '../context/AuthContext.jsx';

export function MyProjectsPage() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const query = (searchParams.get('q') || '').trim().toLowerCase();
  /** @type {[Array<any>, Function]} */
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    apiJson('/api/my/projects')
      .then(setProjects)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (!user?.capabilities?.view_portal_projects) {
    return <p className="muted">Projects are not available on your plan.</p>;
  }

  return (
    <div>
      <PageWelcome title="Projects" subtitle="Track progress and jump into the work that needs you." />
      {loading ? <p className="muted">Loading…</p> : null}
      {error ? <p className="err">{error}</p> : null}
      {!user?.client_id ? (
        <div className="panel">
          <p style={{ margin: 0 }}>Your account is not linked to a client yet. Ask your administrator to attach you to a client record.</p>
        </div>
      ) : projects.length === 0 ? (
        <p className="muted">No projects yet.</p>
      ) : (
        <div className="dash-grid-3" data-tour="projects-list" style={{ marginTop: 0 }}>
          {projects
            .filter((p) => !query || String(p.name || '').toLowerCase().includes(query) || String(p.type || '').toLowerCase().includes(query))
            .map((p) => {
            const percent = p.progress_percent ?? 0;
            return (
              <Link key={p.id} to={`/my/projects/${p.id}`} className="panel" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="project-hero-title-row" style={{ marginBottom: '0.45rem' }}>
                  <strong>{p.name}</strong>
                  <StatusBadge status={p.status} />
                </div>
                <p className="muted small" style={{ margin: '0 0 0.75rem' }}>
                  {p.type}
                </p>
                <ProgressBar value={percent} tone="purple" label={`${percent}% complete`} />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
